/** @format */

// import external modules
import React, { lazy } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute.js";
import { getNotifications } from "../services/socketInstance";
import {
  getTrainer,
  getGym,
  getGymFeatures,
  getUserOpenedStaffSessions,
  getStaffSessionsToVerify,
  unreadNotificationCountApi,
} from "../redux/actions/api/apiAction";
import PublicRouteNoAccess from "./PublicNoAccess.js";
const createBrowserHistory = require("history").createBrowserHistory;

const LazyLogin = lazy(() => import("../views/pages/auth/login"));
const LazyForgotPassword = lazy(() =>
  import("../views/pages/auth/forgotPassword")
);
const LazyServices = lazy(() => import("../views/pages/servicesAndProducts"));
const LazyReSetPassword = lazy(() =>
  import("../views/pages/auth/resetPassword")
);
const LazyGyminfo = lazy(() =>
  import("../views/pages/gymPortion/gyminfo/gymInfo")
);
const LazyStaffsList = lazy(() => import("../components/staff/staffList"));
const LazyGymInfoEdit = lazy(() =>
  import("../views/pages/gymPortion/gyminfo/gymInfoEdit")
);
const LazyTrainerList = lazy(() =>
  import("../views/pages/gymPortion/trainer/trainerList")
);
const LazyTrainerInfo = lazy(() =>
  import("../views/pages/gymPortion/trainer/trainerInfo")
);
const LazyTrainerInfoEdit = lazy(() =>
  import("../views/pages/gymPortion/trainer/trainerEdit")
);
const LazyMembers = lazy(() =>
  import("../views/pages/gymPortion/members/membersList")
);
const LazyMembersCheckIn = lazy(() =>
  import("../views/pages/gymPortion/checkIn/memberList")
);
const LazyMembersInfo = lazy(() =>
  import("../views/pages/gymPortion/members/memberInfov2")
);
const LazyClasses = lazy(() =>
  import("../views/pages/gymPortion/classes/classes")
);
const LazyMembersInfoEdit = lazy(() =>
  import("../views/pages/gymPortion/members/membersEdit")
);
const LazyUnderConstruction = lazy(() =>
  import("../views/pages/errorPage/underConstruction")
);
const LazySetting = lazy(() =>
  import("../views/pages/gymPortion/settingAndSequrity")
);
const Lazywod = lazy(() => import("../views/pages/gymPortion/wod"));
const LazyFollowupProgram = lazy(() => import("../views/pages/gymPortion/followupProgram"));
const LazyVideosLibrary = lazy(() => import("../views/pages/gymPortion/videosLibrary/videosLibrary.jsx"));
const LazyAttachmentLibrary = lazy(() => import("../views/pages/gymPortion/attachmentLibrary/attachmentLibrary.jsx"));


const LazyFinancialParty = lazy(() =>
  import("../views/pages/gymPortion/financialParty/financialParty.js")
);

const LazySettingAndPrivacy = lazy(() =>
  import("../views/pages/gymPortion/settingAndPrivacy")
);
const LazyPackages = lazy(() => import("../views/pages/gymPortion/packages"));
const LazyPackagesEdit = lazy(() =>
  import("../views/pages/gymPortion/packages/editPackage")
);
const LazyReport = lazy(() =>
  import("../views/pages/gymPortion/reports/index")
);
const EmailTemplates = lazy(() => import("../views/pages/emailTemplate.js"));

const LazyDashboard = lazy(() => import("../views/pages/gymPortion/dashboard"));
const LazyEditWod = lazy(() => import("../views/pages/gymPortion/editWod"));
const LazyEditFollowupProgram = lazy(() => import("../views/pages/gymPortion/editFollowupProgram"));
const LazySchedule = lazy(() => import("../views/pages/gymPortion/schedule"));
const LazyEditClass = lazy(() => import("../views/pages/gymPortion/editClass"));
const LazyPyroll = lazy(() => import("../views/pages/payRoll.jsx"));
const LazyManagePyroll = lazy(() => import("../views/pages/managePayroll.js"));
const LazySubscribedUsers = lazy(() =>
  import("../views/pages/subscribedUsers")
);

const LazyTrainerPanelDashBoard = lazy(() =>
  import("../views/pages/trainerPortion/dashboard")
);
const LazyTrainerPanelTrainerInfo = lazy(() =>
  import("../views/pages/trainerPortion/trainer/trainerInfo")
);
const LazyTrainerPanelTrainerInfoEdit = lazy(() =>
  import("../views/pages/trainerPortion/trainer/trainerEdit")
);

const LazyClassDetails = lazy(() =>
  import("../views/pages/services/classDetails")
);
const LazyAppointmentDetails = lazy(() =>
  import("../views/pages/services/appointmentDetails")
);
const LazyEditClassDetails = lazy(() =>
  import("../views/pages/services/editClassDetails")
);
const LazyEditAppointmentDetails = lazy(() =>
  import("../views/pages/services/editAppointmentDetails")
);
const LazyTrainerPanelMembersList = lazy(() =>
  import("../views/pages/trainerPortion/members/membersList")
);
const LazyTrainerPanelPackages = lazy(() =>
  import("../views/pages/trainerPortion/packages")
);
const LazyTrainerPanelSettingAndPrivacy = lazy(() =>
  import("../views/pages/trainerPortion/settingAndPrivacy")
);
const LazyTrainerPanelsettingAndSequrity = lazy(() =>
  import("../views/pages/trainerPortion/settingAndSequrity")
);

const LazyTrainerPanelAppointment = lazy(() =>
  import("../views/pages/trainerPortion/appointments")
);
const LazyTrainerView = lazy(() =>
  import("../views/pages/trainerPortion/trainerView")
);
const LazyTrainerMemberEdit = lazy(() =>
  import("../views/pages/trainerPortion/members/membersEdit")
);
const LazyTrainerMemberInfo = lazy(() =>
  import("../views/pages/trainerPortion/members/membersInfo")
);

const LazyMemberReserve = lazy(() =>
  import("../views/pages/gymPortion/members/reserveMember")
);

const LazyClassPackagesEdit = lazy(() =>
  import("../views/pages/trainerPortion/editTrainerPackage")
);

const LazyError = lazy(() => import("../views/pages/errorPage/error"));

const LazyNotification = lazy(() =>
  import("../views/pages/gymPortion/notification.js")
);
const LazyPushNotification = lazy(() =>
  import("../views/pages/gymPortion/adminPushNotifications/index.js")
);
const LazyBilling = lazy(() => import("../views/pages/gymPortion/billingInfo"));
const LazyCreditCard = lazy(() =>
  import("../views/pages/gymPortion/sucessCase")
);
const LazyLive = lazy(() => import("../views/pages/liveClass"));
export const history = createBrowserHistory({
  basename: "/",
});
const LazyReports = lazy(() =>
  import("../views/pages/gymPortion/reports/reports")
);
const LazyInvoice = lazy(() => import("../components/invoice/index.js"));
const LazyAssessmentTemplate = lazy(() => import("../views/pages/gymPortion/medicalTemplates/assessmentTemplate.js"));
const LazyTreatmentTemplate = lazy(() => import("../views/pages/gymPortion/medicalTemplates/treatmentTemplate.js"));

const LazyInvoiceHistory = lazy(() =>
  import("../components/invoice/invoiceHistory")
);

const LazyBookingDetails = lazy(() =>
  import("../components/dashboard/bookingTable")
);
const LazyBookingDetailsTraniner = lazy(() =>
  import("../components/dashboardGymTrainer/bookingTable")
);
const LazySalesDetails = lazy(() =>
  import("../components/dashboard/salesTable")
);
const LazySalesDetailsTrainer = lazy(() =>
  import("../components/dashboardGymTrainer/salesTable")
);
const LazyOfferSold = lazy(() =>
  import("../components/dashboard/offerSoldTable")
);
const LazyOfferSoldGymTrainer = lazy(() =>
  import("../components/dashboardGymTrainer/offerSoldTable")
);
const LazyOfferSoldTrainer = lazy(() =>
  import("../components/dashboard/offerSoldTable")
);
const LazyTotalClient = lazy(() =>
  import("../components/dashboard/totalClientTable")
);
const LazyComingSoon = lazy(() => import("../views/pages/soon"));
const LazyServicesClasses = lazy(() =>
  import("../views/pages/services/classesList")
);
const LazyServicesWorkshops = lazy(() =>
  import("../views/pages/services/workshopList")
);
const LazyTotalClientGymTrainer = lazy(() =>
  import("../components/dashboardGymTrainer/totalClientTable")
);
const LazyTotalClientTrainer = lazy(() =>
  import("../components/dashboard/totalClientTrainerTable")
);
const LazyClassesTrainer = lazy(() =>
  import("../components/dashboard/classesTrainerTable")
);

const LazyNewMembers = lazy(() =>
  import("../views/pages/gymPortion/members/newMembers")
);

const LazyAppointmentsList = lazy(() =>
  import("../views/pages/services/appointmentsList")
);
const LazyRetailList = lazy(() => import("../views/pages/services/retailList"));
const LazyTherapistJourney = lazy(() => import("../views/pages/gymPortion/trainer/therapistJourney"));

const LazyTrainerPanelClasses = lazy(() =>
  import("../views/pages/trainerPortion/classes/classes")
);
const LazyRedirectFromSupergym = lazy(() =>
  import("../views/pages/auth/redirectFromSuperGym.js")
);

const LazyPaymentGateways = lazy(() =>
  import("../components/paymentGateways/index")
);
const LazyInvoiceProviders = lazy(() =>
  import("../components/invoiceProviders/index.jsx")
);
const LazyGate = lazy(() => import("../views/pages/gymPortion/gate"));
const LazyEditGate = lazy(() => import("../views/pages/gymPortion/editGate"));

const LazyCourtsList = lazy(() =>
  import("../views/pages/gymPortion/courts/courtsList")
);
const LazyCourtInfo = lazy(() =>
  import("../views/pages/gymPortion/courts/courtInfo.js")
);
const LazyCourtInfoEdit = lazy(() =>
  import("../views/pages/gymPortion/courts/courtEdit.js")
);
const LazyCourtsBooking = lazy(() =>
  import("../views/pages/gymPortion/courtsBooking/courtsBookings.jsx")
);

// POS Routes
const LazyPOSLogin = lazy(() => import("../views/pages/pos/POSLogin"));
const LazyPOSMain = lazy(() => import("../views/pages/pos/POSMain"));

const LazyLeads = lazy(() =>
  import("../views/pages/gymPortion/leads/leadList.js")
);
const LazyLeadDetails = lazy(() =>
  import("../views/pages/gymPortion/leads/leadInfo.js")
);
const LazyLeadEditDetails=lazy(()=>import("../views/pages/gymPortion/leads/leadInfoEdit.js"))
const LazyUserFollowups = lazy(() =>
  import("../views/pages/gymPortion/leads/userLeadFollowUps.js")
);
class AppRouter extends React.Component {
  componentDidMount = async () => {
    // Skip all main app initialization logic if we are on POS pages
    if (window.location.pathname.startsWith("/pos")) {
      return;
    }

    if (this.props.isAuthenticated) {
      getNotifications();
      await this.props.unreadNotificationCountApi();

      await this.props.getUserOpenedStaffSessions();
      await this.props.getStaffSessionsToVerify();
    }
    if (this.props.isAuthenticated && this.props.loginUser.role === "TRAINER")
      await this.props.getTrainer(this.props.loginUser.trainer, true);
    if (this.props.isAuthenticated && this.props.loginUser.role === "GYM") {
      await this.props.getGym(this.props.loginUser.gym);
      await this.props.getGymFeatures(this.props.loginUser.gym);
    }
    if (this.props.isAuthenticated && this.props.loginUser.role === "STAFF") {
      await this.props.getGym(this.props.loginUser.staffGym);
      await this.props.getGymFeatures(this.props.loginUser.gym);
    }
  };

  render() {
    return (
      <Router history={history}>
        <div>
          <Switch>
            {/* POS Routes - these must come first and be exact */}
            <Route
              path="/pos/login"
              exact
              render={(props) => <LazyPOSLogin {...props} />}
            />
            <Route
              path="/pos"
              exact
              render={(props) => <LazyPOSMain {...props} />}
            />
            {/* Redirect Route */}
            <PublicRouteNoAccess
              path="/redirect/supergymadmin"
              component={LazyRedirectFromSupergym}
              exact={true}
              fulllayout={true}
            />
            {/* Main App Route - ensure it doesn't match /pos */}
            <PublicRoute
              path="/"
              component={LazyLogin}
              exact={true}
              fulllayout={true}
            />
            <PublicRoute
              path="/forgot-password"
              component={LazyForgotPassword}
              exact={true}
              fulllayout={true}
            />
            <PublicRoute
              path="/gym-panel/reset-password"
              component={LazyReSetPassword}
              exact={true}
            />
            <PublicRoute
              path="/trainer-panel/liveClass"
              component={LazyLive}
              exact={true}
              fulllayout={true}
            />
            <PublicRoute
              path="/gym-panel/reports/:reportName"
              component={LazyReport}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/gym-panel/emailTemplates"
              component={EmailTemplates}
              exact={true}
              fulllayout={false}
            />
            <PublicRoute
              path="/gym-panel/liveClass"
              component={LazyLive}
              exact={true}
              fulllayout={true}
            />
            <PublicRoute
              path="/gym-panel/gyminfo"
              component={LazyGyminfo}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/bookings/classes"
              component={LazyClasses}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/bookings/courts"
              component={LazyCourtsBooking}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/gyminfoedit"
              component={LazyGymInfoEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/staffs"
              component={LazyStaffsList}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/trainerinfolist"
              component={LazyTrainerList}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/trainer/:id"
              component={LazyTrainerInfo}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/trainerinfo/:id"
              component={LazyTrainerInfoEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/leads"
              component={LazyLeads}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/lead/:id"
              component={LazyLeadDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/lead/edit/:id"
              component={LazyLeadEditDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/user/followups"
              component={LazyUserFollowups}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/courtslist"
              component={LazyCourtsList}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/court/:id"
              component={LazyCourtInfo}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/court/:id/edit"
              component={LazyCourtInfoEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/memberslist"
              component={LazyNewMembers}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/check-in"
              component={LazyMembersCheckIn}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/billing"
              component={LazyBilling}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/billing-payment/invoice"
              component={LazyInvoice}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/billing-payment/payment-gateways"
              component={LazyPaymentGateways}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/billing-payment/invoice-providers"
              component={LazyInvoiceProviders}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/templates/assessments"
              component={LazyAssessmentTemplate}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/templates/treatments"
              component={LazyTreatmentTemplate}
              fulllayout={false}
              exact
            />
            
            
            <PublicRoute
              path="/gym-panel/services"
              component={LazyServices}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/invoice/history"
              component={LazyInvoiceHistory}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/reports"
              component={LazyReports}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/editcard"
              component={LazyCreditCard}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/subscribed-users"
              component={LazySubscribedUsers}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/subscribed-users"
              component={LazySubscribedUsers}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/billing"
              component={LazyBilling}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/underconstruction"
              component={LazyUnderConstruction}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/membersinfo/:id"
              component={LazyMembersInfo}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/membersinfo/:id/reserve"
              component={LazyMemberReserve}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/membersinfo/edit/:id"
              component={LazyMembersInfoEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/wod"
              component={Lazywod}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/followup-programs"
              component={LazyFollowupProgram}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/videos-library"
              component={LazyVideosLibrary}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/attachment-library"
              component={LazyAttachmentLibrary}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/followup-programs/:id/edit"
              component={LazyEditFollowupProgram}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/gate"
              component={LazyGate}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/gate/:id"
              component={LazyEditGate}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/financialParty"
              component={LazyFinancialParty}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/wod/:id"
              component={LazyEditWod}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/packages"
              component={LazyPackages}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/packages/:id"
              component={LazyPackagesEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/bookings/appointments"
              component={LazySchedule}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/classes"
              component={LazyServicesClasses}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/workshops"
              component={LazyServicesWorkshops}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/appointments"
              component={LazyAppointmentsList}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/appointments/:id"
              component={LazyAppointmentDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/retail"
              component={LazyRetailList}
              fulllayout={false}
              exact
            />
             <PublicRoute
              path="/gym-panel/therapist/journey"
              component={LazyTherapistJourney}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/classes/:id"
              component={LazyClassDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/edit/classes/:id"
              component={LazyEditClassDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/services/edit/appointment/:id"
              component={LazyEditAppointmentDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard"
              component={LazyDashboard}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/bookings"
              component={LazyBookingDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/dashboard/bookings"
              component={LazyBookingDetailsTraniner}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/sales"
              component={LazySalesDetails}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/dashboard/sales"
              component={LazySalesDetailsTrainer}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/offerSold"
              component={LazyOfferSold}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/dashboard/offerSold"
              component={LazyOfferSoldGymTrainer}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/offerSold/trainer"
              component={LazyOfferSoldTrainer}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/totalClient/trainer"
              component={LazyTotalClientTrainer}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/classes/trainer"
              component={LazyClassesTrainer}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/dashboard/totalClient"
              component={LazyTotalClient}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/dashboard/totalClient"
              component={LazyTotalClientGymTrainer}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/settings"
              component={LazySettingAndPrivacy}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/resetpassword"
              component={LazySetting}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/appointments/:id"
              component={LazyEditClass}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/payroll/define-payrates"
              component={LazyPyroll}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/payroll/manage"
              component={LazyManagePyroll}
              fulllayout={false}
              exact
            />
            {/* trainer routes */}
            <PublicRoute
              path="/trainer-panel/dashboard"
              component={LazyTrainerPanelDashBoard}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/trainerinfo"
              component={LazyTrainerPanelTrainerInfo}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/trainerinfo/edit"
              component={LazyTrainerPanelTrainerInfoEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/memberslist"
              component={LazyNewMembers}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/settings"
              component={LazyTrainerPanelSettingAndPrivacy}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/resetpassword"
              component={LazyTrainerPanelsettingAndSequrity}
              fulllayout={false}
              exact
            />{" "}
            <PublicRoute
              path="/trainer-panel/packages"
              component={LazyTrainerPanelPackages}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/appointments/:id"
              component={LazyEditClass}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/schedule"
              component={LazyCourtsBooking}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/trainerview"
              component={LazyTrainerView}
              fulllayout={true}
              exact
            />
            <PublicRoute
              path="/trainer-panel/membersinfo/:id/edit"
              component={LazyMembersInfoEdit}
              // component={LazyTrainerMemberEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/membersinfo/:id"
              component={LazyTrainerMemberInfo}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/membersinfo/:id/reserve"
              component={LazyMemberReserve}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/packages/:id"
              // component={LazyUnderConstruction}
              component={LazyClassPackagesEdit}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/notification"
              // component={LazyUnderConstruction}
              component={LazyNotification}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/gym-panel/push-notification/management"
              // component={LazyUnderConstruction}
              component={LazyPushNotification}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/notification"
              // component={LazyUnderConstruction}
              component={LazyNotification}
              fulllayout={false}
              exact
            />
            <PublicRoute
              path="/trainer-panel/check-in"
              component={LazyMembersCheckIn}
              fulllayout={false}
              exact
            />
            {/* <PublicRoute
              path="/trainer-panel/billing"
              component={LazyBilling}
              fulllayout={false}
              exact
            /> */}
            <Route component={LazyError} />
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  const isAuthenticated = state.login.loginFlag;
  const loginUser = state.login.loginUser;
  return { isAuthenticated, loginUser };
};

export default connect(mapStateToProps, {
  getTrainer,
  getGym,
  getGymFeatures,
  getUserOpenedStaffSessions,
  getStaffSessionsToVerify,
  unreadNotificationCountApi,
})(AppRouter);
